import { Component, OnInit, Input } from '@angular/core';
import { Kursteilnehmer } from '../_models/teilnehmer';
import { AnwesenheitService } from '../_services/anwesenheit.service';
import { Fehlzeiten } from '../_models/fehlzeiten';
import { NgModel } from '@angular/forms';
import { AuthenticationService } from '../_services/authentication.service';
import { User } from '../_models/user';

@Component({
  selector: 'app-studentabsences',
  templateUrl: './studentabsences.component.html',
  styles: ['td, th {text-align: center; }', '.justify-content-between-margin-correction {margin: 0px;}']
})
export class StudentabsencesComponent implements OnInit {

  constructor(private absencesService: AnwesenheitService, private authService: AuthenticationService) { }

  private _student: Kursteilnehmer;
  @Input() unexcusedChecked: boolean = true;
  @Input() user: User;

  AbsenceRecordToDelete: Fehlzeiten;
  ascending: boolean = false;
  get student() {
    return this._student;
  }

  @Input() set student(student: Kursteilnehmer) {
    this._student = student;

    this.absencesService.getFehlzeitenByTn(this._student.kursteilnehmerNr)
      .subscribe(
        absences => {
          this._student.fehlzeiten = absences;
          //console.log(absences);
        },
        err => console.log(err),
        () => {
          //console.log(this._student);
          if (this.user.activeRole < 16) {
            this._student.fehlzeiten = this._student.fehlzeiten.filter(fz => {
              return fz.datum.substr(0, 10) == new Date().toISOString().substr(0, 10);
            });
          }
        }
      );
  }

  //filter: IFilter = x => x.datum == new Date().toISOString().slice(0, 11).concat("00:00:00");
  filter: IFilterAbsences = x => {
    return !x.entschuldigt || (!this.unexcusedChecked && x.entschuldigt);
  };

  sort: ISortAbsences = (a, b) => {
    if (a.datum > b.datum) return this.ascending ? 1 : -1;
  };


  ngOnInit() {

  }



  onSelectionChanged(event) {
    //console.log(event);
    let id = event.target.parentElement.id;
    let absence = this.student.fehlzeiten.find(x => x.fehlzeitenId == id);
    if (absence.entschuldigung != event.target.text) {
      absence.entschuldigung = event.target.text;
      absence.entschuldigt = absence.entschuldigung == "unentschuldigt" ? false : true;
    }
    this.absencesService.postChangeTnFehlzeiten(absence).subscribe(x => { }, err => console.log(err));
  }

  onDateSortChanged() {
    this.ascending = !this.ascending;
  }

  DeleteAbsence(event) {
    //console.log(event);
    let id: string = event.target.id.substring(3);
    document.getElementById('modalheader').innerText = "Datensatz löschen?";
    this.AbsenceRecordToDelete = this.student.fehlzeiten.filter(f => f.fehlzeitenId == event.target.id.substring(3))[0];
    document.getElementById('modalbody').innerHTML =
      "<Table class='table-sm'><tr><td>Id:</td><td class='text-right'>" + id +
      "</tr><tr><td>Datum:</td><td class='text-right'>" + new Date(this.AbsenceRecordToDelete.datum).toLocaleDateString() +
      "</tr><tr><td>von:</td><td class='text-right'>" + this.AbsenceRecordToDelete.von +
      "</tr><tr><td>bis:</td><td class='text-right'>" + this.AbsenceRecordToDelete.bis +
      "</td></tr></table>";
  }

  DeleteAck() {
    this.absencesService.delete(this.AbsenceRecordToDelete).subscribe(x => { }, err => console.log(err),
      () => {
        let index = this._student.fehlzeiten.indexOf(this.AbsenceRecordToDelete);
        console.log(index);
        this._student.fehlzeiten.splice(index, 1);
        this.AbsenceRecordToDelete = null;
      });
  }
}

interface IFilterAbsences {
  (ab: Fehlzeiten): boolean
}

interface ISortAbsences {
  (a: Fehlzeiten, b: Fehlzeiten): number;
}



// WEBPACK FOOTER //
// ./src/app/_components/studentabsences.component.ts